import PropTypes from 'prop-types';
import React from 'react';

const LogoClear = '/logos/logo-alelo-novo-v2.svg';
const LogoDark = '/logos/logo-alelo-bk-dark-v1.png';
import './Logo.style.scss';

export const Logo = (props) => {
  const getLogo = () => {
    if (props.backgroundTint) {
      return LogoDark;
    }

    return LogoClear;
  };

  return <img src={getLogo()} className="logo-alelo" alt="Logo da Alelo" />;
};

Logo.propTypes = {
  backgroundTint: PropTypes.string
};
